import type { CallbackInterface } from 'recoil'

import { errorUpdater, pageState } from 'State/page'

import type { PageStateType } from 'Types/state'

import { logAppError } from 'Helpers/logger'

import { fetchResultsCallback } from 'Pages/UnsubscriptionCampaignsList/recoil/callbacks/results'
import {
  modalActivateSimulateState,
  modalCopyState,
  modalDeleteState,
  modalSimulateState,
} from 'Pages/UnsubscriptionCampaignsList/recoil/state/modals'
import {
  copyWorkflow,
  deleteWorkflow,
  notifyCopy,
  notifyDelete,
} from 'Pages/UnsubscriptionCampaignsList/services/modals'
import { fetchWorkflow } from 'Pages/UnsubscriptionCampaignsList/services/results'
import type { ModalActivateSimulateState } from 'Pages/UnsubscriptionCampaignsList/types'

export const modalCopyOpenCallback =
  ({ set }: CallbackInterface) =>
  async (idWorkflow: number) => {
    set(modalCopyState, (prev) => ({ ...prev, show: true, idWorkflow }))
  }

export const modalCopyCancelCallback =
  ({ reset }: CallbackInterface) =>
  async () => {
    reset(modalCopyState)
  }

export const modalCopyConfirmCallback =
  ({ set, reset, snapshot, ...cbi }: CallbackInterface) =>
  async () => {
    const { idWorkflow } = await snapshot.getPromise(modalCopyState)

    set(modalCopyState, (prev) => ({ ...prev, fetching: true }))

    try {
      const result = await copyWorkflow(idWorkflow)

      void fetchResultsCallback({ set, reset, snapshot, ...cbi })({})

      notifyCopy(result)
    } catch (error) {
      console.error('### error', error)

      logAppError({
        Component: 'UnsubscriptionCampaignsList',
        Method: 'modalCopyConfirmCallback',
        appError: error,
      })
      set<PageStateType>(pageState, errorUpdater)
    }

    reset(modalCopyState)
  }

//

export const modalSimulateOpenCallback =
  ({ set, snapshot }: CallbackInterface) =>
  async (idWorkflow: number) => {
    //  set(modalSimulateState, (prev) => ({ ...prev, show: true, idWorkflow }))

    try {
      const item = await fetchWorkflow(idWorkflow)

      set<ModalActivateSimulateState>(modalActivateSimulateState, (prev) => ({
        ...prev,
        idWorkflow,
        mode: 'simulate',
        show: true,
        recipientLimit: item.RecipientLimit ?? 0,
      }))
    } catch (error) {
      console.error('### error', error)

      logAppError({
        Component: 'UnsubscriptionCampaignsList',
        Method: 'modalSimulateOpenCallback',
        appError: error,
      })
      set<PageStateType>(pageState, errorUpdater)
    }
  }

export const modalSimulateCancelCallback =
  ({ reset }: CallbackInterface) =>
  async (idWorkflow: number) => {
    reset(modalSimulateState)
  }

//

export const modalDeleteOpenCallback =
  ({ set }: CallbackInterface) =>
  async (idWorkflow: number, name: string) => {
    set(modalDeleteState, (prev) => ({ ...prev, show: true, idWorkflow, name }))
  }

export const modalDeleteCancelCallback =
  ({ reset }: CallbackInterface) =>
  async () => {
    reset(modalDeleteState)
  }

export const modalDeleteConfirmCallback =
  ({ set, reset, snapshot, ...cbi }: CallbackInterface) =>
  async () => {
    set<PageStateType>(pageState, (prev) => ({
      ...prev,
      loading: true,
    }))

    const { idWorkflow } = await snapshot.getPromise(modalDeleteState)

    try {
      await deleteWorkflow(idWorkflow)

      void fetchResultsCallback({ set, reset, snapshot, ...cbi })({})

      notifyDelete()
    } catch (error) {
      console.error('### error', error)

      logAppError({
        Component: 'UnsubscriptionCampaignsList',
        Method: 'modalDeleteConfirmCallback',
        appError: error,
      })
      set<PageStateType>(pageState, errorUpdater)
    }

    reset(modalDeleteState)

    set<PageStateType>(pageState, (prev) => ({
      ...prev,
      loading: false,
    }))
  }

//

export const modalActivateSimulateCloseCallback =
  ({ reset }: CallbackInterface) =>
  async () => {
    reset(modalActivateSimulateState)
  }
